module.exports = __webpack_public_path__ + "static/media/Hbook-07.ebd91aa3.jpg";